import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import { rootRoute } from '../services/routing/rootRoute';
import { routeLabels } from '../services/routing/routeMetadata';

export const devToolsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/devtools',
  component: lazyRouteComponent(() => import('../components/pages/PuffinDevToolsPage/PuffinDevToolsPage'), 'PuffinDevToolsPage'),
  staticData: { ...routeLabels('Puffin Dev Tools'), navigationPath: '/devtools' },
});
